import { getShiftDate } from "./dateTimeFormatter";
import { getStationTimeZoneLuxonDateTimeFromIsoDateString } from "./timeZoneService";

// ***** Common *****
export const REFERENCE_NUMBER_SUB_TITLE = (referenceNumber) => {
  return `Reference # ${referenceNumber}`;
};

export const GENERIC_TRY_AGAIN_ERROR_MESSAGE = "Error. Please try again.";

export const IF_ERROR_PERSISTS_CONTACT_HELP_DESK_MESSAGE = "If error persists, contact the Help Desk.";

export const IF_ERROR_PERSISTS_CONTACT_HELP_DESK_WITH_ERROR_REFERENCE_ID_MESSAGE =
  "If error persists, contact the Help Desk with the Error Reference ID above.";

export const GENERIC_LOADING_MESSAGE = "Loading...";

export const ADMIN_MOBILE_WARNING_MESSAGE = "Administrator functions are not supported on this screen size!";

export const NO_ACCESS_TO_PAGE_MESSAGE = "You do not have access to this page!";

export const NO_APP_ACCESS_WARNING_MESSAGE = "You are not authorized to use this application!";

export const START_DATE_IS_REQUIRED = "Start Date is required";

export const END_DATE_IS_REQUIRED = "End Date is required";

export const START_TIME_IS_REQUIRED = "Start Time is required";

export const END_TIME_IS_REQUIRED = "End Time is required";

export const INVALID_REFERENCE_NUMBER_ERROR_MESSAGE = "Invalid Reference #";

export const ARE_YOU_SURE_YOU_WANT_TO_CANCEL_MESSAGE = "Are you sure you want to Cancel?";

export const ARE_YOU_SURE_YOU_WANT_TO_CANCEL_DIALOG_MESSAGE = (actionType) => {
  return `Are you sure you want to cancel? All ${actionType} will be lost.`;
};
export const ARE_YOU_SURE_YOU_WANT_TO_LEAVE_PAGE_DIALOG_MESSAGE = (actionType) => {
  return `Are you sure you want to leave this page? All ${actionType} will be lost.`;
};

export const ARE_YOU_SURE_YOU_WANT_TO_LEAVE_THIS_PAGE_DATA_WILL_BE_LOST_MESSAGE =
  "Are you sure you want to leave this page? All data will be lost.";

export const ARE_YOU_SURE_YOU_WANT_TO_SAVE_YOUR_CHANGES_MESSAGE = "Are you sure you want to save your changes?";

export const ARE_YOU_SURE_YOU_WANT_TO_ACCEPT_MESSAGE = "Are you sure you want to Accept?";

export const ARE_YOU_SURE_YOU_WANT_TO_RETRACT_MESSAGE = "Are you sure you want to Retract?";

export const ARE_YOU_SURE_YOU_WANT_TO_APPROVE_MESSAGE = "Are you sure you want to Approve?";

export const ARE_YOU_SURE_YOU_WANT_TO_REFUSE_MESSAGE = "Are you sure you want to Refuse?";

export const ARE_YOU_SURE_YOU_WANT_TO_REINSTATE_MESSAGE = "Are you sure you want to Reinstate?";

export const ARE_YOU_SURE_YOU_WANT_TO_DECLINE_MESSAGE = "Are you sure you want to Decline?";

export const UNKNOWN_ACTION_MESSAGE = (actionSelected) => `Unknown Action: ${actionSelected}`;

export const END_DATE_CANNOT_BE_MORE_THAN_TWO_MONTHS_IN_PAST = "End Date cannot be more than 2 months in the past";

export const _4_HOUR_VAC_SHIFT_WARNING_MESSAGE = "Shift length must be\n4 hours";

export const HAT_SHIFT_MIN_MAX_WARNING_MESSAGE = "Shift length must be within 1 and 7 hours";

export const HAT_SHIFT_1_HOUR_INCREMENT_WARNING_MESSAGE = "Shift must be in 1-hour increments";

export const WOP_RELEASE_MIN_TIME_WARNING_MESSAGE = "Request cannot be less than 15 minutes";

export const WOP_RELEASE_WITHIN_SHIFT_TIME_WARNING_MESSAGE = "Request must be within Shift Time";

export const WOP_START_END_TIME_IN_PAST_WARNING_MESSAGE = "Start/End Time cannot be in the past";

export const MAX_8_AND_ONE_HALF_HOURS_WARNING_MESSAGE = "Shift cannot exceed 8.5 hours";

export const MIN_SHIFT_30_MINUTES_WARNING_MESSAGE = "Shift cannot be less than 30 minutes";

export const MAX_SHIFT_10_AND_ONE_HALF_HOURS_WARNING_MESSAGE = "Shift cannot exceed 10.5 hours";

export const HAVE_YOU_CONTACTED_THE_EMPLOYEE_VERBALLY = "Have you contacted the Employee verbally?";

export const ERROR_MESSAGE = "Error";

export const COMPLETED_MESSAGE = "Completed";

export const PLEASE_DO_NOT_REFRESH_OR_CLOSE_YOUR_SCREEN_MESSAGE = "Please do not refresh or close your screen!";

export const START_DATE_CANNOT_BE_IN_THE_PAST = "Start Date cannot be in the past";

export const START_DATE_AFTER_END_DATE_ERROR = "Start Date cannot be after End Date";

export const END_DATE_BEFORE_START_DATE_ERROR = "End Date cannot be before Start Date";

export const CHAR_LIMIT_MESSAGE = (charLimit) => {
  return "Comments cannot be longer than " + charLimit + " characters";
};

export const COMMENTS_REQUIRED = "Comments are required";

export const LABOR_CONTACT_REQUIRED = "Labor Contact is required";

export const INVALID_EMPLOYEE_ID = "Invalid Employee ID";

export const EMPLOYEE_ID_REQUIRED = "Employee ID is required";

// ***** Trade *****
export const REQUEST_TRADE_TITLE = "Request Trade";

export const TRADE_CONFIRMATION_TITLE = "Trade Confirmation";

export const YOU_CANNOT_APPROVE_YOUR_OWN_TRADE_MESSAGE = "You cannot approve your own trade!";

export const YOU_CANNOT_REFUSE_YOUR_OWN_TRADE_MESSAGE = "You cannot refuse your own trade!";

export const YOU_CANNOT_REINSTATE_YOUR_OWN_TRADE_MESSAGE = "You cannot reinstate your own trade!";

export const YOU_CANNOT_APPROVE_YOUR_OWN_TRADE_CANCELLATION_MESSAGE = "You cannot approve your own trade cancellation!";

export const YOU_CANNOT_REFUSE_YOUR_OWN_TRADE_CANCELLATION_MESSAGE = "You cannot refuse your own trade cancellation!";

export const YOU_CANNOT_CANCEL_YOUR_OWN_TRADE_FROM_THE_TRADE_ADMIN_SCREEN_MESSAGE =
  "You cannot cancel your own trade from the Trade Administration screen!";

export const ARE_YOU_SURE_YOU_WANT_TO_SUBMIT_THE_TRADE_MESSAGE = "Are you sure you want to submit the trade?";

export const ARE_YOU_SURE_YOU_WANT_TO_SUBMIT_THE_REQUEST_MESSAGE = "Are you sure you want to submit the request?";

export const TRADE_CREATED_MESSAGE = "The trade has been created!";

export const TRADE_OFFERED_MESSAGE = "Your trade has been offered!";

export const TRADE_TYPE_IS_REQUIRED_MESSAGE = "Trade Type is required";

export const TRADE_ELIGIBILITY_TITLE = "Trade Eligibility";

export const TRADE_ELIGIBILITY_ERROR_MESSAGE =
  "Unable to process request because at least one Employee will not be working in this station during that time.";

// ***** Time Off Request *****
export const REQUEST_TIME_OFF_TITLE = "Request Time Off";

export const TIME_OFF_CONFIRMATION_TITLE = "Time Off Confirmation";

export const REQUEST_WOP_TITLE = "Request LWOP/TOWOP";

export const YOU_CANNOT_CANCEL_TOR_PAST_DEADLINE_ONE_HOUR_BEFORE_SHIFT_MESSAGE =
  "You cannot cancel time off past the deadline:\n 1 hour before shift!";

export const YOU_CANNOT_CANCEL_TOR_PAST_SHIFT_END_TIME_MESSAGE = "You cannot cancel time off past the deadline.";

export const YOU_CANNOT_RETRACT_TOR_PAST_DEADLINE_ONE_HOUR_BEFORE_SHIFT_MESSAGE =
  "You cannot retract time off past the deadline:\n 1 hour before shift!";

export const YOU_CANNOT_RETRACT_TOR_PAST_SHIFT_END_TIME_MESSAGE = "You cannot retract time off past the deadline.";

export const YOU_CANNOT_CANCEL_AN_APPROVED_EAD_EDY_MESSAGE = "You cannot cancel an approved EAD/EDU!";

export const YOU_CANNOT_APPROVE_TOR_PAST_DEADLINE_MESSAGE = "You cannot approve time off past the deadline!";

export const YOU_CANNOT_APPROVE_TOR_PAST_DEADLINE_START_TIME_OF_SHIFT_MESSAGE =
  "You cannot approve time off past the deadline: start time of shift!";

export const YOU_CANNOT_REFUSE_TOR_PAST_DEADLINE_MESSAGE = "You cannot refuse time off past the deadline!";

export const YOU_CANNOT_REFUSE_TOR_PAST_DEADLINE_START_TIME_OF_SHIFT_MESSAGE =
  "You cannot refuse time off past the deadline: start time of shift!";

export const YOU_CANNOT_APPROVE_CANCEL_TOR_PAST_DEADLINE_MESSAGE =
  "You cannot approve a time off cancellation past the deadline!";

export const YOU_CANNOT_APPROVE_CANCEL_TOR_PAST_DEADLINE_START_TIME_OF_SHIFT_MESSAGE =
  "You cannot approve a time off cancellation past the deadline: start time of shift!";

export const YOU_CANNOT_REFUSE_CANCEL_TOR_PAST_DEADLINE_MESSAGE =
  "You cannot refuse a time off cancellation past the deadline!";

export const YOU_CANNOT_REFUSE_CANCEL_TOR_PAST_DEADLINE_START_TIME_OF_SHIFT_MESSAGE =
  "You cannot refuse a time off cancellation past the deadline: start time of shift!";

export const YOU_CANNOT_CANCEL_TOR_OVER_TWO_MONTHS_IN_PAST = "You cannot cancel time off over 2 months in the past!";

export const YOU_CANNOT_REINSTATE_TOR_OVER_TWO_MONTHS_IN_PAST =
  "You cannot reinstate time off over 2 months in the past!";

export const YOU_CANNOT_APPROVE_YOUR_OWN_TOR = "You cannot approve your own time off!";

export const YOU_CANNOT_REFUSE_YOUR_OWN_TOR = "You cannot refuse your own time off!";

export const YOU_CANNOT_APPROVE_YOUR_OWN_TOR_CANCELLATION = "You cannot approve your own time off cancellation!";

export const YOU_CANNOT_REFUSE_YOUR_OWN_TOR_CANCELLATION = "You cannot refuse your own time off cancellation!";

export const YOU_CANNOT_CANCEL_YOUR_OWN_TOR_FROM_TOR_ADMIN_SCREEN =
  "You cannot cancel your own time off from the Time Off Administration screen!";

export const YOU_CANNOT_REINSTATE_YOUR_OWN_TOR = "You cannot reinstate your own time off!";

export const ARE_YOU_SURE_WANT_TO_SUBMIT_THE_TIME_OFF_REQUEST = "Are you sure you want to submit the time off request?";

export const ARE_YOU_SURE_WANT_TO_SUBMIT_THE_TIME_OFF_REQUESTS =
  "Are you sure you want to submit the time off requests?";

export const ARE_YOU_SURE_WANT_TO_CREATE_THE_TIME_OFF_REQUEST = "Are you sure you want to create the time off request?";

export const ARE_YOU_SURE_WANT_TO_CREATE_THE_TIME_OFF_REQUESTS =
  "Are you sure you want to create the time off requests?";

export const TOR_MULTIPLE_REQUESTS_CREATED_MESSAGE = "The time off requests have been created!";

export const TOR_SINGLE_REQUEST_CREATED_MESSAGE = "The time off request has been created!";

export const TOR_MULTIPLE_REQUESTS_SUBMITTED_MESSAGE = "Your time off requests have been submitted!";

export const TOR_SINGLE_REQUEST_SUBMITTED_MESSAGE = "Your time off request has been submitted!";

export const LWOP_TOWOP_ALL_DAY_DEADLINE_MESSAGE =
  "Sign-ups received by 11:00 AM will be considered first. Later requests will be accepted until midnight.";

export const EAD_EDU_SEAD_MISSING_REQUEST_TIME_MESSAGE = `If shift time is unknown, enter "00:00" for start and end times.`;

export const WARNING_ONE_REQUEST_HAS_NO_SHIFT_TIME =
  "The time off request does not contain shift times. When the Employee's shift times are known, please cancel the time off and create a new one with the known shift times.";

export const WARNING_MULTIPLE_REQUESTS_HAVE_NO_SHIFT_TIME =
  "At least 1 time off request does not contain shift times. When the Employee's shift times are known, please cancel the time off and create new one(s) with the known shift times.";

export const SHIFT_TIME_IS_REQUIRED = "Shift time is required";

export const INVALID_START_DATE = "Invalid Start Date";

export const INVALID_END_DATE = "Invalid End Date";

export const START_DATE_MUST_MATCH_END_DATE = "Start Date must match End Date";

export const MINIMUM_SHIFT_LENGTH_WARNING__4_HOURS = "Shift cannot be less than 4 hours";

export const MINIMUM_SHIFT_LENGTH_WARNING__1_HOUR = "Shift cannot be less than 1 hour";

export const TIME_OFF_TYPE_IS_REQUIRED_MESSAGE = "Time Off Type is required";

export const TIME_OFF_REQUEST_NOT_AUTHORIZED_ERROR_MESSAGE = "You are not authorized to access this time off request";

export const TIME_OFF_ELIGIBILITY_ADMIN_WARNING =
  "Unable to process request because the Employee will not be working in this station during that time.";

export const TIME_OFF_ELIGIBILITY_EMPLOYEE_WARNING =
  "Unable to process request because you will not be working in this station during that time.";

// TOR Admin Canned Reason Messages - START

export const _4_HOUR_VAC_HAT_MUST_BE_AT_BEGINNING_OR_END_OF_SHIFT =
  "4-Hour VAC/HAT must be at beginning or end of shift";
export const DAILY_ALLOTMENT_IS_ALREADY_FULL = "Daily allotment is already full";
export const DUPLICATE_REQUEST = "Duplicate request";
export const EMPLOYEE_IS_ALREADY_OFF = "Employee is already off";
export const FTO_DAT_BID_HAS_NOT_BEEN_AWARDED = "FTO/DAT Bid has not been awarded";
export const INCORRECT_TIMES_OR_SHIFT_LENGTH = "Incorrect times or shift length";
export const INELIGIBLE_EMPLOYEE = "Ineligible Employee";
export const INSUFFICIENT_TIME_OFF_BALANCES = "Insufficient time off balances";
export const OVERLAPS_WITH_TRAINING_OR_OVERTIME = "Overlaps with training or overtime";
export const PARTIAL_SHIFT_MUST_BE_SUBMITTED_AS_4HOUR_VAC_HAT = "Partial shift must be submitted as 4-Hour VAC/HAT";
export const PTO_BID_HAS_NOT_BEEN_AWARDED = "PTO Bid has not been awarded";
export const SUBMITTED_AFTER_CUTOFF_TIME = "Submitted after cutoff time";
export const WILL_CREATE_MOT = "Will create MOT";
export const WILL_CREATE_VOT = "Will create VOT";
export const SHIFT_HAS_BEEN_COVERED_BY_OVERTIME_OR_RELIEF = "Shift has been covered by overtime or relief";
export const EARNED_AWARD_DAY_CREATED_WITH_SHIFT_TIMES = "Earned Award Day created with shift times";
export const EMPLOYEE_HAS_BECOME_INELIGIBLE = "Employee has become ineligible";
export const OTHER = "Other";

export const EMPLOYEE_ON_OVERTIME_WILL_BE_OFFERED_RELEASE =
  "Employees on overtime will be offered release prior to awarding LWOP/TOWOP";
export const WOP_REQUEST_MUST_BE_AT_BEGINNING_OR_END = "LWOP/TOWOP must be requested at the beginning or end of shift";

// TOR Admin Canned Reason Messages - END

// ***** Temp Assignments *****
export const TEMP_ASSIGNMENT_CONFIRMATION_TITLE = "Temporary Assignment Confirmation";

export const TEMP_ASSIGNMENT_ACTION_ERROR_TITLE = "Temp Assignment Action Error";

export const TEMP_ASSIGNMENT_CREATE_CONFIRM_MESSAGE = (firstName, lastName, eid) => {
  return {
    __html: `Are you sure you want to create the temporary assignment for <b>${lastName}, ${firstName} (${eid})</b>?`,
  };
};
export const TEMP_ASSIGNMENT_EDIT_CONFIRM_MESSAGE = (firstName, lastName, eid) => {
  return {
    __html: `Are you sure you want to edit the temporary assignment for <b>${lastName}, ${firstName} (${eid})</b>?`,
  };
};
export const TEMP_ASSIGNMENT_CREATE_SUCCESS_MESSAGE = (firstName, lastName, eid) => {
  return {
    __html: `The temporary assignment for <b>${lastName}, ${firstName} (${eid})</b> has been created!`,
  };
};
export const TEMP_ASSIGNMENT_EDIT_SUCCESS_MESSAGE = (firstName, lastName, eid) => {
  return {
    __html: `The temporary assignment for <b>${lastName}, ${firstName} (${eid})</b> has been updated! `,
  };
};
export const TEMP_ASSIGNMENT_CANCEL_MESSAGE = (firstName, lastName, eid) => {
  return {
    __html: `Are you sure you want to cancel the temporary assignment for <b>${lastName}, ${firstName} (${eid})</b>? `,
  };
};

export const TEMP_ASSIGNMENT_SUBMISSION_ERROR_MESSAGE = "Could not submit Temporary Assignment. Please try again";

export const CONTACT_NUMBER_REQUIRED = "Contact # is required";

export const INVALID_CONTACT_NUMBER = "Invalid Contact #";

export const PHONE_REQUIRED = "Phone # is required";

export const INVALID_PHONE_NUMBER = "Invalid Phone #";

export const EXISTING_OVERLAPPING_TEMP_ASSIGNMENT_ERROR = (tempAssignment) => {
  const tempStation = tempAssignment.tempStation;
  const startDate = getShiftDate(
    getStationTimeZoneLuxonDateTimeFromIsoDateString(tempAssignment.startDate, tempStation)
  );
  const endDate = getShiftDate(getStationTimeZoneLuxonDateTimeFromIsoDateString(tempAssignment.endDate, tempStation));
  return `Employee already has a temporary assignment in ${tempStation} from ${startDate} to ${endDate}`;
};

export const CANNOT_ENTER_PARTIAL_BASE_SCHEDULE = "Cannot enter a partial schedule";

export const BASE_SCHEDULE_REQUIRES_EMPLOYEE_ID = "Cannot enter a schedule without Employee ID";

export const SCHEDULE_EXCEEDS_40_HOURS_WARNING_MESSAGE = "Schedule cannot exceed 40 hours";

export const SHIFT_OVERLAPS_WITH_PREVIOUS_SHIFT_WARNING_MESSAGE = "Shift overlaps with previous shift";

export const DATE_TYPE_FILTER_MUST_BE_SELECTED = "Date Type filter must be selected";

export const INCOMING_OUTGOING_FILTER_MUST_BE_SELECTED = "At least one Incoming/Outgoing filter must be selected";

export const STATUS_FILTER_MUST_BE_SELECTED = "At least one Status must be selected";

export const BID_TYPE_FILTER_MUST_BE_SELECTED = "At least one Bid Type must be selected";

export const WORKGROUP_FILTER_MUST_BE_SELECTED = "At least one Workgroup must be selected";

export const STATION_FILTER_MUST_BE_SELECTED = "Station filter must be selected";

export const POSITION_FILTER_MUST_BE_SELECTED = "At least one Position filter must be selected";

export const ASSIGNMENT_FILTER_MUST_BE_SELECTED = "At least one Assignment filter must be selected";

export const DAYS_OFF_FILTER_MUST_BE_SELECTED = "At least one Days Off filter must be selected";

export const START_TIME_FILTER_MUST_BE_SELECTED = "At least one Start Time filter must be selected";

export const TEMP_ASSIGNMENT_NOT_AUTHORIZED_ERROR_MESSAGE = "You are not authorized to access this Temp Assignment";

export const TEMP_ASSIGNMENT_BASE_SCHEDULE_DONE_MESSAGE = "Done";

export const TEMP_ASSIGNMENT_BASE_SCHEDULE_MISSING_MESSAGE = "Missing";

export const YOU_CANNOT_EDIT_TEMPORARY_ASSIGNMENT_OVER_TWO_MONTHS_IN_PAST =
  "You cannot edit a temporary assignment over 2 months in the past!";

export const TEMP_ASSIGNMENT_SELF_ACTION_CREATE_WARNING_MESSAGE = "You cannot create a temp assignment for yourself";

export const TEMP_ASSIGNMENT_SELF_ACTION_EDIT_WARNING_MESSAGE = `You cannot edit your own temp assignment!`;

export const TEMP_ASSIGNMENT_SELF_ACTION_CANCEL_WARNING_MESSAGE = `You cannot cancel your own temp assignment!`;

export const TEMP_ASSIGNMENT_SELF_ACTION_WARNING_MESSAGE = (actionType) => {
  return `You cannot ${actionType} your own temp assignment!`;
};

export const TEMP_ASSIGNMENT_CLOCK_LOCATION_MESSAGE =
  "Employee will be automatically assigned in Kronos to their Temp Station workgroup clocks. If the Employee needs to be assigned to a different clock, please follow the current manual process.";

// ***** Seniority List *****
export const SENIORITY_LIST_TEMP_MOBILE_MESSAGE = "Seniority List is currently not supported on mobile.";

export const SENIORITY_MISSING_DATA_WARNING_HEADER = "NON-CRITICAL ERROR";
export const SENIORITY_MISSING_DATA_WARNING_MESSAGE = "Data is missing, but not affecting seniority ranking.";

export const SENIORITY_MISSING_DATA_ERROR_HEADER = "CRITICAL ERROR";
export const SENIORITY_MISSING_DATA_ERROR_MESSAGE =
  "Data is missing. Unable to determine seniority ranking until corrected.";

export const SENIORITY_MISSING_PHONE_NUMBER_MESSAGE =
  "Phone number is missing, please update using the Employee Management Screen";

export const SENIORITY_BIRTHDAY_MESSAGE = "Happy Birthday!";

export const SENIORITY_MISSING_FTPT_WARNING_MESSAGE = "FT/PT data missing";

export const SENIORITY_COLLISIONS_WARNING_MESSAGE =
  "Employees have identical dates and seniority ranking cannot be determined.  Please contact GOSAT (GOAdministration@wnco.com) to set their ranking";

export const SENIORITY_COLLISIONS_MESSAGE =
  "Seniority ranking tiebreaker between these Employees has been previously determined and order is correct.";

export const UNABLE_TO_DETERMINE_SENIORITY_RANKING = "Unable to determine seniority ranking";

// ***** Reporting *****
export const REPORT_TYPE_IS_REQUIRED = "Report Type is required";

export const ARE_YOU_SURE_YOU_WANT_TO_GENERATE_THE_REPORT_MESSAGE = "Are you sure you want to generate the report?";

export const REPORT_GENERATION_WARNING_MESSAGE =
  "This report only contains scheduling conflicts currently in STARS for outgoing Employees.";

export const GENERATING_REPORT_MESSAGE = "Generating Report";

export const GENERATE_REPORT_MESSAGE = "Generate Report";

export const YOUR_REPORT_FAILED_TO_GENERATE_PLEASE_TRY_AGAIN_MESSAGE =
  "Your report failed to generate! Please try again.";

export const YOUR_REPORT_HAS_BEEN_GENERATED_MESSAGE = "Your report has been generated!";

export const EMPLOYEE_TRADE_ROLE_IS_REQUIRED_MESSAGE = "Employee Trade Role is required";

export const WORKGROUP_IS_REQUIRED_MESSAGE = "Workgroup is required";

export const STATUS_IS_REQUIRED_MESSAGE = "Status is required";

export const SHIFT_DATE_IS_REQUIRED_MESSAGE = "Shift Date is required";

export const DATE_TYPE_IS_REQUIRED_MESSAGE = "Date Type is required";

export const CRITICAL_WARNING_FOR_SL_PDF = "Critical data errors found, contact GOSAT before exporting as a PDF!";

export const TEMP_ASSIGNMENT_EDIT_WARNING_MESSAGE =
  "Editing this temp assignment may lead to conflicts with existing schedules.";

export const TEMP_ASSIGNMENT_CANCEL_INFO_MESSAGE =
  "If you are trying to change the temporary assignment dates, please use the EDIT button.";

export const TEMP_ASSIGNMENT_CANCEL_WARNING_MESSAGE =
  "Cancelling this temp assignment may lead to conflicts with existing schedules.";

export const CANCEL_TEMPORARY_ASSIGNMENT_TITLE = "Cancel Temporary Assignment";

export const WARNING_ALERT_TITLE = "WARNING";

export const SCHEDULE_CONFLICT_REPORT_ALERT_MESSAGE =
  "This report provides a list of approved scheduling events currently in STARS that conflict with Employees' outgoing Temp Assignments during the selected time period.";

export const ARE_YOU_SURE_YOU_WANT_TO_REMOVE_ACCESS_DIALOG_MESSAGE =
  "Are you sure you want to remove the access exception?";

export const ACCESS_EXCEPTION_OUTGOING_TEMP_ASSIGNMENT_ERROR =
  "This Employee is currently on a temporary assignment. Removing this exception will restore default access when they return.";

export const ACCESS_EXCEPTION_NO_LONGER_VALID_TEMP_ASSIGNMENT_ERROR = "This access exception no longer applies.";

export const REMOVE_EXCEPTION = "Remove Exception";

export const ARE_YOU_SURE_YOU_WANT_TO_SAVE_CHANGES_DIALOG_MESSAGE = (lastName, firstName) => {
  return {
    __html: `You are saving the changes you made to <b>${lastName}, ${firstName}. </b>`,
  };
};

export const SAVE_CHANGES_TITLE = "Save changes";

export const EMPLOYEE_DATA_SAVE_MESSAGE = "Employee data saved successfully.";

export const EMPLOYEE_DATA_CONFIRMATION_TITLE = "Changes Saved";

export const EMPLOYEE_DATA_MANAGEMENT_SUBMISSION_ERROR_MESSAGE = "Could not save Employee data. Please try again";

export const TECH_USER_LOCAL_SERVICE_VERSIONS_INFO_MESSAGE = (eastLocalVersionCount, westLocalVersionCount) => {
  if (eastLocalVersionCount && westLocalVersionCount) {
    return `Warning: ${eastLocalVersionCount} functions in us-east-1 and ${westLocalVersionCount} in us-west-2 have been detected with 'local' versions. This may result in inconsistent testing outcomes. Please make sure to deploy them via CI/CD pipeline`;
  } else if (eastLocalVersionCount) {
    return `Warning: ${eastLocalVersionCount} functions in us-east-1 have been detected with 'local' versions. This may result in inconsistent testing outcomes. Please make sure to deploy them via CI/CD pipeline`;
  } else if (westLocalVersionCount) {
    return `Warning: ${westLocalVersionCount} functions in us-west-2 have been detected with 'local' versions. This may result in inconsistent testing outcomes. Please make sure to deploy them via CI/CD pipeline`;
  } else {
    return "";
  }
};

export const FEATURE_ACCESS_CONFIRMATION_TITLE = "Feature Access Confirmation";

export const FEATURE_ACCESS_CHANGES_SAVED_MESSAGE = "Feature Access changes saved successfully.";

export const ERROR_LOADING_LAMBDA_SERVICE_VERSIONS_MESSAGE = "Error Loading Service Versions";

export const MY_PERMANENT_BID_IAM_TITLE = "My Permanent Bid (IAM)";

export const MY_PERMANENT_BID_TWU_TITLE = "My Permanent Bid (TWU)";

export const MANAGE_PERMANENT_BID_TITLE = "Manage Permanent Bid";

export const PREFERENCE_PRIORITY_MESSAGE =
  "If there is not an exact match, which preference is more important to you? Please select one.";

export const CUSTOMER_SERVICE_PERMANENT_BID_MESSAGE = "Customer Service Agent Permanent Shift Bid";

export const UPDATE_PERMANENT_BID_FIELDS_ALERT_MESSAGE =
  "Update your permanent bid preferences by selecting values from the Days Off, Preference, and Start Time fields.";

export const ENTER_PREFERENCE_FOR_HOLIDAYS = "Enter your preferences for Thanksgiving Day and Christmas Day.";

export const THANKS_GIVING_DAY_PERMANENT_BID = "Thanksgiving Day Holiday Permanent Bid";

export const CHRISTMAS_DAY_PERMANENT_BID = "Christmas Day Holiday Permanent Bid";

export const ENTER_PREFERENCE = "ENTER PREFERENCE";

export const PREFERENCES_ENTERED = "Preferences Entered: ";

export const LAST_UPDATED = "Last updated by ";

export const LAST_UPDATED_TIMESTAMP = "Last updated ";

export const POSITIONS_AND_ASSIGNMENTS_ARE_SUBJECT_TO_CHANGE_MESSAGE =
  "Positions and Assignments are subject to change.";

export const EXPORT_PDF = "Export(PDF)";

export const TWU_PERMANENT_BID_MESSAGE =
  "Southwest Airlines Ramp, Operations, Air Freight and Provisioning Permanent Shift Bid";

export const UPDATE_PERMANENT_BID_TWU_ALERT_MESSAGE =
  "Update your Permanent Bid preferences by selecting values from the Days Off, Shift, and Start Time fields.";

export const PERMANENT_BID_SAVE_MESSAGE = "Your Permanent Bid preferences have been updated!";

export const SUCCESS_TITLE = "Success!";

export const CANCEL_TITLE = "Cancel";

export const REMOVE_TITLE = "Remove";

export const DELETE_PERMANENT_BID_EMPLOYEE_TITLE = "Delete my Permanent Bid";
export const DELETE_PERMANENT_BID_ADMIN_TITLE = "Delete the Permanent Bid";

export const PERMANENT_BID_CANCEL_MESSAGE = () => {
  return {
    __html: `Are you sure you want to leave the Permanent Bid Screen? <br> <br> Any unsubmitted changes will be lost.`,
  };
};

export const BID_FORM_GUIDE_MESSAGE = () => {
  return {
    __html: `<ol><li>Filter which bid lines you want to see with the <b>FILTERS</b> button. You can filter bid lines by Position, Days Off, and/or Start Time.</li>
    <li>Tap/Click <b>+</b> to select the bid lines in your preferred order.</li>
    <li>Tap/Click <b>NEXT</b> to see all your choices. You can reorder them before you submit.</li></ol>`,
  };
};

export const MY_BID_RESULTS_DIALOG_MESSAGE = "You didn't participate in this Bid.";

export const MY_BID_RESULTS_DIALOG_UNAWARDED_MESSAGE = "You weren't awarded any time off in this Bid.";

export const BID_FORM_CANCEL_MESSAGE =
  "Are you sure you want to leave this screen?\n\nAny unsubmitted choices will be lost.";

export const PERMANENT_BID_DELETE_MESSAGE_ADMIN = "This will delete the Employee’s Permanent Bid on file.";
export const PERMANENT_BID_DELETE_MESSAGE_EMPLOYEE = "This will delete your Permanent Bid on file.";

export const SUBMIT_PERMANENT_BID_TITLE = "Submit my Permanent Bid";

export const SUBMIT_PERMANENT_BID_DIALOG_TITLE = "This will override any existing Permanent Bid you have on file.";

export const CLEAR_ALL_PREFERENCES = "Clear all preferences";
export const CLEAR_ALL_PREFERENCES_MESSAGE = "Are you sure you want to clear all the Permanent Bid preferences?";

export const BID_FORM_CLEAR_ALL = "Clear All Choices";
export const BID_FORM_CLEAR_ALL_CHOICES_MESSAGE = "You are removing all the choices you entered on the screen.";

export const DUPLICATE_PREFERENCE_ALERT_MESSAGE =
  "The shift in red is a duplicate. Please remove and select another shift preference.";

export const NO_PREFERENCE_ALERT_MESSAGE = "At least 1 preference is required.";

export const NO_ROWS_MESSAGE = {
  noRowsLabel: "No Preferences",
};

export const PERMANENT_BID_SUBMISSION_ERROR_MESSAGE = "Could not save the Permanent Bid. Please try again.";

export const SUBMIT_PERMANENT_BID_AS_ADMIN_DIALOG_TITLE =
  "This will override any existing Permanent Bid on file for the selected Employee.";

export const PERMANENT_BID_SAVE_AS_ADMIN_MESSAGE =
  "The Permanent Bid preferences have been updated for the selected Employee.";

export const PERMANENT_BID_NON_CONTRACT_ERROR_MESSAGE = "Cannot create Permanent Bid for non-contract Employees";

export const ADMIN_SELF_BID_CREATE_ERROR = "Cannot create Permanent Bid for yourself";

export const SUBMIT_PERMANENT_BID_ADMIN_TITLE = "Submit Permanent Bid";

export const PUBLISH_SENIORITY_LIST_MESSAGE = "The Seniority List has been published successfully.";
export const PUBLISH_SENIORITY_LIST_ERROR_MESSAGE = "Could not publish the Seniority list. Please try again.";

export const PERMANENT_BID_DELETE_MESSAGE = "Your Permanent Bid preferences have been deleted!";
export const PERMANENT_BID_DELETE_AS_ADMIN_MESSAGE =
  "The Permanent Bid preferences have been deleted for the selected Employee.";
export const PERMANENT_BID_DELETION_ERROR_MESSAGE = "Could not delete the Permanent Bid. Please try again.";

export const PUBLISH_ERROR_TITLE = "Unable to publish";

export const EDM_INFO_MESSAGE =
  "Updates to PT/FT or Seniority Date fields will make temporary changes to the In Progress Seniority List and notify GO Administration.  Once the In Progress Seniority List is accurate, publish the list. If updates are not resolved in STARS by the following day, the In Progress Seniority List will revert back, but the Published Seniority List will not be affected.";

export const BID_GROUP_EMPLOYEE_REMOVAL_WARNING_MESSAGE = (lastName, firstName) => {
  return {
    __html: `Removing Employees from the Bid Group will not affect the Seniority List. Enter the reason for removing <b>${lastName}, ${firstName}</b> from the Bid Group.`,
  };
};

export const BID_GROUP_EMPLOYEE_REMOVAL_TITLE = "Remove Employee";

export const BID_LINES_IMPORT_ERROR_MESSAGE =
  "Errors were found. There may be missing fields or incorrect formatting preventing a successful import. \n\n Please ensure that there are no empty data fields and that the Bid Line CSV is in the required format. Once resolved, load the CSV again.";

export const BID_LINES_REIMPORT_CONFIRMATION_MESSAGE =
  "The current Bid Lines will be overwritten. Are you sure you want to re-load the Bid Lines?";

export const MANAGE_SHIFT_BID_INELIGIBLE_DIALOG_MESSAGE = (lastName, firstName, ineligibility) => {
  return {
    __html: `Enter the reason for marking <b>${lastName}, ${firstName}</b> as ${ineligibility}.`,
  };
};

export const BID_GROUP_ADD_EMPLOYEE_WARNING_MESSAGE = "Cannot add Employees until all Employees are ranked.";

export const INVALID_BID_GROUP_RANK = "Invalid Bid Group Rank";

export const BID_LINES_IMPORT_SUCCESS = "Bid lines imported successfully.";

export const SHIFT_BID_CHOICE_CONFIRMATION_TITLE = "Shift Bid Choice Confirmation";

export const SHIFT_BID_CHOICE_CONFIRMATION_MESSAGE = "Your Shift bid choices have been submitted!";

export const FREEDAY_BID_CHOICE_CONFIRMATION_TITLE = "Freeday Bid Choice Confirmation";

export const FREEDAY_BID_CHOICE_CONFIRMATION_MESSAGE = "Your Freeday bid choices have been submitted!";

export const FTO_BID_CHOICE_CONFIRMATION_TITLE = "FTO Bid Choice Confirmation";

export const FTO_BID_CHOICE_CONFIRMATION_MESSAGE = "Your FTO bid choices have been submitted!";

export const DAT_BID_CHOICE_CONFIRMATION_TITLE = "DAT Bid Choice Confirmation";

export const DAT_BID_CHOICE_CONFIRMATION_MESSAGE = "Your DAT bid choices have been submitted!";

export const DAT_FTO_BID_CHOICE_CONFIRMATION_TITLE = "DAT/FTO Bid Choice Confirmation";

export const DAT_FTO_BID_CHOICE_CONFIRMATION_MESSAGE = "Your DAT/FTO bid choices have been submitted!";

export const BID_CHOICE_SAVE_ERROR_MESSAGE = "Unexpected error occurred. Your choices could not be submitted.";

export const BID_PUBLISH_DIALOG_MESSAGE = (station, workgroup, schedDates) => {
  return {
    __html: `<b>${station} | ${workgroup} | ${getShiftDate(schedDates[0])} | ${getShiftDate(
      schedDates[1]
    )}</b><br>Publishing will finalize this bid and immediately notify the Employees of the bid results.
    <br>This may take a few minutes. Your patience is appreciated. <span style="color:black">🙂</span>`,
  };
};

export const FREEDAY_BID_PUBLISH_DIALOG_MESSAGE = (station, workgroup, schedMonth, schedYear) => {
  return {
    __html: `<b>${station} | ${workgroup} | ${schedYear} ${schedMonth.substr(
      0,
      3
    )}</b><br>Publishing will finalize this bid and immediately notify the Employees of the bid results.
    <br>This may take a few minutes. Your patience is appreciated. <span style="color:black">🙂</span>`,
  };
};

export const BLOCK_LINE_ASTERISK_MESSAGE = "Block lines are denoted with an asterisk in the Bid Line column.";

export const SCHEDULE_END_DATE_CHANGE_MESSAGE =
  "You're trying to change the Bid Effective End Date. If this is for a contract bid, please contact your Labor Manager before proceeding.";

export const NO_CHOICES_ROW_MESSAGE = {
  noRowsLabel: "No Choices",
};

export const IAM_FTO_BID_PUBLISH_DIALOG_MESSAGE = (station, workgroup, schedMonth, schedYear) => {
  return {
    __html: `<b>${station} | ${workgroup} | ${schedYear} ${schedMonth.substr(
      0,
      3
    )}</b><br>Publishing will finalize this bid and immediately notify the Employees of the bid results.
    <br>This may take a few minutes. Your patience is appreciated. <span style="color:black">🙂</span>`,
  };
};

export const TWU_DAT_FTO_BID_PUBLISH_DIALOG_MESSAGE = (station, workgroup, schedMonth, schedYear) => {
  return {
    __html: `<b>${station} | ${workgroup} | ${schedYear} ${schedMonth.substr(
      0,
      3
    )}</b><br>Publishing will finalize this bid and immediately notify the Employees of the bid results.
    <br>This may take a few minutes. Your patience is appreciated. <span style="color:black">🙂</span>`,
  };
};

export const IAM_DAT_BID_PUBLISH_DIALOG_MESSAGE = (station, workgroup, schedMonth, schedYear) => {
  return {
    __html: `<b>${station} | ${workgroup} | ${schedYear} ${schedMonth.substr(
      0,
      3
    )}</b><br>Publishing will finalize this bid and immediately notify the Employees of the bid results.
    <br>This may take a few minutes. Your patience is appreciated. <span style="color:black">🙂</span>`,
  };
};

export const MY_DECLARATIONS_IAM_TITLE = "Customer Service - Vacation Declaration Form";

export const MY_DECLARATIONS_TWU_TITLE =
  "Ramp, Operations, Cargo and Provisioning Vacation and Freeday/FTO Declaration Form";

export const DECLARATION_FORM_CANCEL_MESSAGE =
  "Are you sure you want to leave this screen?\n\nAny unsubmitted choices will be lost.";

export const DECLARATION_ROUND_CLOSED = "Declaration Round closed";

export const DECLARATION_SUCCESS_MESSAGE_DIALOG = "Declaration has been updated successfully!";

export const DECLARATION_YEAR_SELECTION_CHANGE =
  "Are you sure you want to change the Declaration Year?\n\nAny unsubmitted entries will be lost.";

export const DECLARATION_ERROR_MESSAGE_DIALOG = "Unexpected error occurred. Your Declaration could not be submitted.";

export const SHIFT_BID_MUST_PUBLISH_BEFORE_WARNING_MESSAGE =
  "Shift bid must be published for the entire month before setting up the time off bid.";

export const FREEDAY_OR_IAM_FTO_BID_MUST_PUBLISH_BEFORE_WARNING_MESSAGE =
  "Freeday/IAM-FTO bids must be published for the entire month before setting up the time off bid.";

export const IGNORE_UNWANTED_FIELDS_IN_DECLARATION_PAGES_IAM = () => (
  <>
    Do not make any <b>2025</b> updates for CSAs.
  </>
);

export const IGNORE_UNWANTED_FIELDS_IN_DECLARATION_PAGES_TWU = () => (
  <>
    For 2025 updates, modify only the Freeday/FTO selections. <b>Do not make changes to any other fields.</b>
  </>
);

export const PTO_FTO_BID_CHOICE_CONFIRMATION_TITLE = "PTO/FTO Bid Choice Confirmation";

export const PTO_FTO_BID_CHOICE_CONFIRMATION_MESSAGE = "Your PTO/FTO bid choices have been submitted!";

export const PTO_GOC_HOL_BID_CHOICE_CONFIRMATION_TITLE = "PTO/GOC-HOL Bid Choice Confirmation";

export const PTO_GOC_HOL_BID_CHOICE_CONFIRMATION_MESSAGE = "Your PTO/GOC-HOL bid choices have been submitted!";

export const LABOR_CONTACT_CHAR_LIMIT = "Labor Contact cannot be longer than 50 characters";

export const NC_BID_PUBLISH_DIALOG_MESSAGE = (station, workgroup, schedMonth, schedYear) => {
  return {
    __html: `<b>${station} | ${workgroup} | ${schedYear} ${schedMonth.substr(
      0,
      3
    )}</b><br>Publishing will finalize this bid and immediately notify the Employees of the bid results.
    <br>This may take a few minutes. Your patience is appreciated. <span style="color:black">🙂</span>`,
  };
};
